import { useMemo } from 'react';

import useDashboardWidgets from '@/features/dashboard/hooks/useDashboardWidgets';
import useCurrentHome from '@/features/homeAutomation/hooks/useCurrentHome';

import { DEFAULT_SAUNA_WIDGET_CONFIG, mergeSaunaWidgetConfig, type SaunaWidgetConfig } from './config';

export default function useSaunaWidgetConfig(): SaunaWidgetConfig {
  const { data: resolved } = useDashboardWidgets();
  const home = useCurrentHome();
  return useMemo(() => {
    const entry = resolved?.find((r) => r.id === 'sauna');
    const stored = (entry?.doc?.config as Partial<SaunaWidgetConfig> | undefined) ?? null;
    const merged = stored ? mergeSaunaWidgetConfig(stored) : DEFAULT_SAUNA_WIDGET_CONFIG;
    if (merged.homeId) return merged;
    return { ...merged, homeId: home.data?.id ?? null };
  }, [resolved, home.data?.id]);
}
